import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rcp-page',
  template: ` <ng-content /> `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--section-padding);
      flex-grow: 1;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageComponent {}
